import { appConstants } from "../helpers/app-constants";

const intialState = {
  homeData: [],
  homeNewData:[],
  loader: {
    ftype: "",
    state: true,
  },
  stockData:[],
  realData:[],

};

// home reducer
export const Home = (state = intialState, action) => {
  switch (action.type) {
    case "LOADER":
      return {
        ...state,
        loader: { ftype: action.ftype, state: action.payload },
      };
    case appConstants.GET_HOME_DATA:
      return {
        ...state,
        homeData: action.payload,
      };
    case appConstants.GET_STOCK_DATA:
      return {
        ...state,
        stockData: action.payload,
      };
    case appConstants.GET_REAL_DATA:
      return {
        ...state,
        realData: action.payload,
      };
    case appConstants.GET_HOME_NEW_DATA:
    return {
        ...state,
        homeNewData: action.payload,
    };
    default:
      return state;
  }
};
